async function checkAndAddGiftProducts() {
  console.log('function called')
    try {
        // Fetch the current cart contents
        const response = await fetch('/cart.json');
        const cart = await response.json();
        console.log('cart')
        console.log(cart)

        let bookCount = 0;
        let bookCost = 0;

        // Calculate the total number of books and their cost
        cart.items.forEach(item => {
            if (item.product_type === 'Book') { // Ensure product type is correctly set
                bookCount += item.quantity;
                bookCost += item.final_price * item.quantity / 100; // Convert from cents
            }
        });
      console.log('bookCount')
      console.log(bookCount)
      console.log('bookCost')
      console.log(bookCost)

        // Gift product variant IDs
        const miniCourse = 50281627779391; // First gift product
        const oneHour = 50281655337279; // Second gift product
        const contentAudit = 50281655271743; // Third gift product
        const workshop = 50281653207359; // Fourth gift product

        // Helper function to add a gift product if not already in the cart
        const addGiftProduct = async (variantId) => {
          console.log('in add gift')
            const exists = cart.items.some(item => item.variant_id === variantId);
            if (!exists) {
          console.log('gift not exist')
                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: variantId, quantity: 1 })
                });
            }
        };

        // Helper function to remove a gift product if it exists in the cart
        const removeGiftProduct = async (variantId) => {
          console.log('remove gift')
            const existingItem = cart.items.find(item => item.variant_id === variantId);
            if (existingItem) {
          console.log(existingItem)
          console.log('irrelevant gift exist')
                await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: existingItem.key, quantity: 0 })
                });
            }
        };

        // Adjust the gift products based on the conditions
        if (bookCount >= 1 && bookCount < 10 && bookCost >= 94) {
          console.log('1book')
            // Add miniCourse and workshop, and remove other gifts
            await addGiftProduct(miniCourse);
            await addGiftProduct(workshop);
            await removeGiftProduct(contentAudit);
            await removeGiftProduct(oneHour);
        } else if (bookCount >= 10 && bookCount < 25 && bookCost >= 294) {
          console.log('10 book')
            // Add miniCourse, workshop, and contentAudit, and remove oneHour
            await addGiftProduct(miniCourse);
            await addGiftProduct(workshop);
            await addGiftProduct(contentAudit);
            await removeGiftProduct(oneHour);
        } else if (bookCount >= 25 && bookCost >= 694) {
          console.log('25 book')
            // Add miniCourse, workshop, and oneHour, and remove contentAudit
            await addGiftProduct(miniCourse);
            await addGiftProduct(workshop);
            await addGiftProduct(oneHour);
            await removeGiftProduct(contentAudit);
        } else {
          console.log('none book')
            // If none of the conditions match, remove all gift products
            await removeGiftProduct(miniCourse);
            await removeGiftProduct(workshop);
            await removeGiftProduct(contentAudit);
            await removeGiftProduct(oneHour);
        }
    } catch (error) {
        console.error('Error checking or adding gift products:', error);
    }
}
document.addEventListener('DOMContentLoaded', () => {
  console.log('DOMContentLoaded')
    checkAndAddGiftProducts(); // Automatically check and add gift products on page load
});

// Optionally, listen for changes in the cart
document.addEventListener('cart:update', () => {
  console.log('cart:update')
    checkAndAddGiftProducts();
});

const originalFetch = window.fetch;
window.fetch = async function (...args) {
    const response = await originalFetch(...args);
    if (args[0].includes('/cart') && (args[1]?.method === 'POST' || args[1]?.method === 'PUT')) {
        const event = new CustomEvent('cart:update');
        document.dispatchEvent(event);
    }
    return response;
};